/* Hook encargado de actualizar el video del vehículo
Autor: Ashutosh Dhanda
Fecha: 2024-03-21
*/
import { useState } from 'react'

import { customPost } from '../utils/customFetch'

import { makeUrlVehicleVideoEdit } from './connectionData'

interface VideoUpdateParams {
  vehicleId: string
  videoUrl: string
}

const useVehicleVideoPoster = () => {
  const [errorPostVideo, setErrorPostVideo] = useState<Error | null>(null)
  const [loadingPost, setLoadingPost] = useState<boolean>(false)

  const postVideoUrl = async (params: VideoUpdateParams) => {
    setLoadingPost(true)

    try {
      const apiUrl = makeUrlVehicleVideoEdit()
      await customPost<void>(apiUrl, params)
      setErrorPostVideo(null)

      return 'OK'
    } catch (err) {
      if (err instanceof Error) {
        setErrorPostVideo(err)
      } else {
        setErrorPostVideo(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoadingPost(false)
    }
  }

  return { errorPostVideo, loadingPost, postVideoUrl }
}

export default useVehicleVideoPoster
